import { PRODUCTS } from "../../assets";

export const vat = 10;

export const tableHeaders = ["Product", "Price", "Quantity", "Subtotal", ""];

export const user = {
  name: "",
  email: "",
};

export const order = {
  subTotal: 0,
  total: 0,
  vat: 0,
  delivery: 0,
};

export const products = [
  {
    id: 1,
    name: "Futuristic smart watch",
    price: 1000,
    image: PRODUCTS.watch,
    sku: "476843",
  },
  {
    id: 2,
    name: "Red nike running shoes",
    price: 500,
    image: PRODUCTS.nike,
    sku: "436823",
  },
  {
    id: 3,
    name: "Vintage HD camera",
    price: 1500,
    image: PRODUCTS.camera,
    sku: "437723",
  },
  {
    id: 4,
    name: "3 in 1 classic socks",
    price: 5,
    image: PRODUCTS.socks,
    sku: "436000",
  },
  {
    id: 5,
    name: "Soda",
    price: 0.1,
    image: PRODUCTS.drink,
    sku: "425823",
  },
  {
    id: 6,
    name: "Durable hikers backpack",
    price: 100,
    image: PRODUCTS.backpack,
    sku: "436823",
  },
  {
    id: 7,
    name: "All black tinted sunglasses",
    price: 10,
    image: PRODUCTS.glasses,
    sku: "336823",
  },
  {
    id: 8,
    name: "Noise blocker headphones",
    price: 250,
    image: PRODUCTS.headphones,
    sku: "324723",
  },
];
